import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import { FiLock, FiArrowRight, FiEye, FiEyeOff, FiKey } from 'react-icons/fi';

import {
  RegisterPage, GameBg, PageBody,
  CentreCol, RegisterCard, FieldGroup,
  SubmitBtn, CardFooter, ErrorText, ShowHideBtn,
} from './RegisterStyle';

import { changePassword } from '../../../store/auth/authSlice';

const ChangePassword = () => {
  const { t } = useTranslation();
  const toast = useToast({ position: 'top', duration: 5000, status: 'error' });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  const { register, handleSubmit, formState: { errors } } = useForm();
  const [searchParams] = useSearchParams();
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  useEffect(() => {
    if (!searchParams.get('token')) navigate('/login');
  }, [navigate, searchParams]);

  return (
    <RegisterPage>
      <GameBg>
        <PageBody>
          <CentreCol>
            <RegisterCard>
              <div className="card-top-icon">
                <FiKey size={18} />
              </div>

              <h2 className="card-title">{t('pages.auth.change_password')}</h2>
              <p className="card-subtitle">أدخل كلمة المرور الجديدة لحسابك</p>

              <form onSubmit={handleSubmit(values => {
                dispatch(changePassword({ token: searchParams.get('token'), values }))
                  .unwrap()
                  .then(() => navigate('/login'))
                  .catch(error => {
                    toast({ description: error.errors?.[0]?.msg });
                  });
              })}>
                <FieldGroup>
                  <span className="field-label">{t('pages.auth.password')}</span>
                  <div className="field-wrap">
                    <FiLock className="field-icon" />
                    <input
                      type={isPasswordShown ? 'text' : 'password'}
                      placeholder="••••••••"
                      style={{ paddingRight: '36px' }}
                      {...register('password', {
                        required: t('validation.required'),
                        minLength: { value: 8, message: `${t('validation.min_length')} 8` },
                      })}
                    />
                    <ShowHideBtn type="button" onClick={() => setIsPasswordShown(v => !v)}>
                      {isPasswordShown ? <FiEyeOff size={14} /> : <FiEye size={14} />}
                    </ShowHideBtn>
                  </div>
                  {errors.password && <ErrorText>{errors.password.message}</ErrorText>}
                </FieldGroup>

                <SubmitBtn type="submit" disabled={auth.isLoading}>
                  {auth.isLoading
                    ? '...'
                    : <>{t('pages.auth.change_password')} <FiArrowRight size={16} /></>
                  }
                </SubmitBtn>

                <CardFooter>
                  <span className="footer-text">{t('pages.auth.have_an_account')}</span>
                  <Link to="/login" className="signin-link">
                    {t('pages.auth.login')} <FiArrowRight size={12} />
                  </Link>
                </CardFooter>
              </form>
            </RegisterCard>
          </CentreCol>
        </PageBody>
      </GameBg>
    </RegisterPage>
  );
};

export default ChangePassword;
